module.exports = __webpack_public_path__ + "images/850da98f156f290fe4a4ea1d5d8673dbf261b391ff1dc836307a89835c781bfe.svg";